module.exports = __webpack_public_path__ + "static/media/CornerSplit_After.def20e08.jpg";